// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1bxGD","file":"styles_file__17Fh6"};